import React, { useEffect, useState, useCallback } from 'react';
import { getdatausr, svdatausr, svdatausr2 } from '../../services/StudentService';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { Context } from '../../index';
import { toast } from 'react-toastify';
import kommuner from '../RegisterPage/kommuner.json';
import ToggleButton from '../../UI/ToggleButton/Togglebutton';
import { PiUserListLight } from "react-icons/pi";
import Autocomplete from "./Autocomplete";
import useIsMobile from "../../utils/useIsMobile";
import {FaRegUser, FaRegEnvelope, FaRegAddressCard, FaCar, FaCity, FaToggleOn, FaPhone} from 'react-icons/fa'; // Import icons for specific fields

const MyDetailsPage = () => {
    const { register, handleSubmit, formState: { errors }, setValue, getValues } = useForm({
        mode: 'onChange',
    });
    const navigate = useNavigate();
    const { store } = useContext(Context);
    const [userData, setUserData] = useState(null);
    const [editableField, setEditableField] = useState(null);
    const [autotransmission, setAutotransmission] = useState();
    const [loading, setLoading] = useState(true);



    // Fetch user data and update form values
    const fetchData = useCallback(async () => {
        try {
            const studentId = store.user.id;
            const userDetails = await getdatausr(studentId);
            setUserData(userDetails.data);
            setAutotransmission(userDetails.data.autotransmission);

            // Set initial form values when data is fetched
            setValue('name', userDetails.data.name);
            setValue('surname', userDetails.data.surname);
            setValue('email', userDetails.data.email);
            setValue('city', userDetails.data.city);
            setValue('pnr', userDetails.data.pnr);
            setValue('phone', userDetails.data.phone);
            setValue('category', userDetails.data.category?.join(','));

        } catch (error) {
            toast.error('Error fetching user details');
        } finally {
            setLoading(false);
        }
    }, [setValue, store.user.id]);


    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleEditClick = useCallback((fieldName) => {
        setEditableField(fieldName);
    }, []);

    const handleSaveClick = useCallback(async (fieldName) => {
        try {
            const updatedData = {
                name: fieldName === 'name' ? getValues('name') : userData.name,
                surname: fieldName === 'surname' ? getValues('surname') : userData.surname,
                email: fieldName === 'email' ? getValues('email') : userData.email,
                city: fieldName === 'city' ? getValues('city') : userData.city,
                pnr: fieldName === 'pnr' ? formatPersonnummer(getValues('pnr')) : userData.pnr,
                phone: fieldName === 'phone' ? formatPhoneNumber(getValues('phone')) : userData.phone,
                category: fieldName === 'category' ? getValues('category').split(',').map(item => item.trim()) : userData.category,
            };

            await svdatausr(store.user.id, updatedData);
            toast.success('Uppdaterad!');
            setEditableField(null);
            fetchData();  // Re-fetch data to update the form after saving
        } catch (error) {
            toast.error('Ops... något gick fel! Dubbelkolla dina uppgifter');
        }
    }, [fetchData, getValues, store.user.id, userData]);

    const handleSaveClick2 = useCallback(async (newAutotransmissionValue) => { // Accept the new value as a parameter
        try {
            const updatedData = {
                autotransmission: newAutotransmissionValue,
            };
            await svdatausr2(store.user.id, updatedData);
            toast.success('Uppdaterad!');
        } catch (error) {
            toast.error('Ops... något gick fel!');
        }
    }, [store.user.id]);




    const formatPersonnummer = (value) => {
        if (!value) return value;
        const regex = /^(\d{8})-?(\d{4})$/;
        const match = value.match(regex);
        if (match) {
            return match.slice(1, 3).join('');
        } else {
            throw new Error('Fel format av personnummer');
        }
    };

    const formatPhoneNumber = (value) => {
        if (!value) return value;
        const regex = /^\d{10}$/;
        if (regex.test(value)) {
            return `${value}`;
        } else {
            throw new Error('Fel format av tel.nummer');
        }
    };


    const renderEditableField = useCallback((fieldName, fieldType, label) => {
        if (!userData) return null;
        return (
            <>
                {fieldType === 'text' && (
                    <div className='pl-16 pr-16 pt-32'>
                        <div className='pb-8'>{label}: {userData[fieldName]}</div>
                        <input
                            type="text"
                            {...register(fieldName)}
                            defaultValue={userData[fieldName]}
                        />
                    </div>
                )}

                {fieldType === 'text2' && (
                    <div className='pl-16 pr-16 pt-32'>
                        <p className='p-8' style={{ color: 'grey', fontStyle: 'italic' }}>10 siffror, exempel: 0701234567</p>

                        <input
                            type="text2"
                            {...register(fieldName)}
                            defaultValue={userData[fieldName]}
                        />
                    </div>
                )}       {fieldType === 'text3' && (
                <div className='pl-16 pr-16 pt-32'>
                    <p className='p-8' style={{ color: 'grey', fontStyle: 'italic' }}>12 siffror ex: 19950115-1234</p>

                    <input
                        type="text2"
                        {...register(fieldName)}
                        defaultValue={userData[fieldName]}
                    />
                </div>
            )}
                {fieldType === 'toggle' && (
                    <div className='pl-16 pr-16 pt-32'>
                        <div className='pt-16'>{label}: {userData[fieldName] ? 'Nej' : 'Ja'}</div>
                        <label className="switch">
                            <input
                                type="checkbox"
                                {...register(fieldName)}
                                defaultChecked={userData[fieldName]}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>
                )}
                {fieldType === 'select' && (
                    <div>
                        <div className='pt-16'>{label}: {userData[fieldName]}</div>
                        <select
                            {...register('category')}
                            defaultValue={userData[fieldName]?.join(',')}
                        >
                            <option value="CategoryB">CategoryB</option>
                            <option value="CategoryA">CategoryA</option>
                        </select>
                    </div>
                )}
                {fieldType === 'select2' && (
                    <div>
                        <div className='pt-16 pb-8'>{label}: {userData[fieldName]}</div>
                        <Autocomplete
                            suggestions={kommuner}
                            onSelect={(selectedCity) => setValue('city', selectedCity)}
                            initialValue={userData[fieldName]}
                        />
                        {errors?.city && <p className='description error'>{errors.city.message}</p>}
                    </div>
                )}
                <button className='button' style={{ maxWidth: 130 }} onClick={() => handleSaveClick(fieldName)}>Spara</button>
            </>
        );
    }, [errors, register, userData, setValue, handleSaveClick]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!userData) {
        return <div>Error loading data</div>;
    }

    return (
        <div style={{ maxWidth: "570px", margin: "0 auto" }}>
            <div className="card2 center mt-128 mb-128 ml-8 mr-8">

                <PiUserListLight style={{ width: '30px', height: '30px', color: "#61588e" }} />
                <h2 className=" pt-8 mb-32">Dina uppgifter</h2>
                <div className='mb-16 pt-8'>
                    <div className='mb-16 pt-8 flex center'>
                        Kör du en automatväxellåda?
                    </div>
                    <ToggleButton
                        type="checkbox"
                        className='mt-16'
                        checked={autotransmission}
                        onChange={(newState) => {
                            setAutotransmission(newState); // Update the parent state for display
                            handleSaveClick2(newState); // Call the save function with the NEW value
                        }}
                    />

                </div>
                {editableField === 'name' ? (
                    renderEditableField('name', 'text', 'Namn')
                ) : (
                    <div className='pt-32'>
                        <div className='pt-8 flex center'>
                            <FaRegUser style={{ marginRight: '8px', color: "#61588e" }} />
                            Ditt namn
                        </div>
                        <h3 className='pt-16'>{userData.name}</h3>
                        <button className='ghostbutton mt-16' style={{ maxWidth: '100px' }} onClick={() => handleEditClick('name')}>Ändra?</button>
                    </div>
                )}

                {editableField === 'surname' ? (
                    renderEditableField('surname', 'text', 'Efternamn')
                ) : (
                    <div className='pt-32'>
                        <div className='pt-8 flex center'>
                            <FaRegUser style={{ marginRight: '8px', color: "#61588e" }} />
                            Ditt efternamn
                        </div>
                        <h3 className='pt-16'>{userData.surname || 'Ej angett'}</h3>
                        <button className='ghostbutton mt-16' style={{ maxWidth: '100px' }} onClick={() => handleEditClick('surname')}>Ändra?</button>
                    </div>
                )}

                {editableField === 'email' ? (
                    renderEditableField('email', 'text', 'E-mail')
                ) : (
                    <div className='pt-32'>
                        <div className='pt-8 flex center'> {/* Added flex and items-center for alignment */}
                            <FaRegEnvelope style={{ marginRight: '8px', marginTop: '2px', color: "#61588e" }} /> {/* Icon component */}
                            Din e-mail
                        </div>                        <h3 className='pt-16'>{userData.email}</h3>
                        <button className='ghostbutton mt-16' style={{ maxWidth: '100px' }} onClick={() => handleEditClick('email')}>Ändra?</button>
                    </div>
                )}

                {editableField === 'pnr' ? (
                    renderEditableField('pnr', 'text3', 'Personnummer')
                ) : (
                    <div className='pt-32'>
                        <div className='pt-8 flex center'>
                            <FaRegAddressCard style={{ marginRight: '8px',  marginTop: '2px',  color: "#61588e" }} />
                            Personnummer
                        </div>                        <h3 className='pt-16'>{userData.pnr || 'Ej angett'}</h3>
                        <button className='ghostbutton mt-16' style={{ maxWidth: '100px' }} onClick={() => handleEditClick('pnr')}>Ändra?</button>
                    </div>
                )}

                {editableField === 'phone' ? (
                    renderEditableField('phone', 'text2', 'Telefonnummer')
                ) : (
                    <div className='pt-32'>
                        <div className='pt-8 flex center'>
                            <FaPhone style={{ marginRight: '8px',  color: "#61588e" }} />
                            Ditt telefonnummer
                        </div>   <h3 className='pt-16'>{userData.phone || 'Ej angett'}</h3>

                        <button className='ghostbutton mt-16' style={{ maxWidth: '100px' }} onClick={() => handleEditClick('phone')}>Ändra?</button>
                    </div>
                )}

                {editableField === 'category' ? (
                    renderEditableField('category', 'select', 'Kategorin')
                ) : (
                    <div className='pt-32'>
                        <div className='pt-8 flex center'>
                            <FaCar style={{ marginRight: '8px',  marginTop: '2px',  color: "#61588e" }} />
                            Körkortskategori
                        </div>                        <h3 className='pt-16'>{userData.category || 'Ej angett'   }</h3>
                        <button className='ghostbutton mt-16' style={{ maxWidth: '100px' }} onClick={() => handleEditClick('category')}>Ändra?</button>
                    </div>
                )}

                {editableField === 'city' ? (
                    renderEditableField('city', 'select2', 'Välj din kommun')
                ) : (
                    <div className='pt-32'>
                        <div className='pt-8 flex center'>
                            <FaCity style={{ marginRight: '8px',  marginTop: '2px',  color: "#61588e" }} />
                            Välj din kommun
                        </div>                        <h3 className='pt-16'>{userData.city || 'Ej angett' }</h3>
                        <button className='ghostbutton mt-16' style={{ maxWidth: '100px' }} onClick={() => handleEditClick('city')}>Ändra?</button>
                    </div>
                )}


            </div>
        </div>
    );
};
export default MyDetailsPage;
